import { render, staticRenderFns } from "./EducationalQualificationUpsertForm.vue?vue&type=template&id=71ba1b98"
import script from "./EducationalQualificationUpsertForm.vue?vue&type=script&lang=ts"
export * from "./EducationalQualificationUpsertForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports